import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PublicPage, PageHero, Seo } from "@/components/public/PublicChrome";

const COLS = [
  { key: "planned", label: "Planned", dot: "bg-blue-400" },
  { key: "in_progress", label: "In Progress", dot: "bg-amber-400" },
  { key: "completed", label: "Shipped", dot: "bg-emerald-400" },
];

export default function Roadmap() {
  const [data, setData] = useState({ planned: [], in_progress: [], completed: [] });
  useEffect(() => { api.get("/roadmap").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <PublicPage>
      <Seo title="Product Roadmap" description="What we're building next at Fairview Systems." path="/roadmap" />
      <PageHero eyebrow="Trust Center" title="Product Roadmap" subtitle="Shaped by customer votes. See what's planned, in progress, and shipped." />
      <div className="max-w-6xl mx-auto px-6 pb-24 grid md:grid-cols-3 gap-4" data-testid="roadmap-board">
        {COLS.map((c) => (
          <div key={c.key}>
            <div className="flex items-center gap-2 mb-3">
              <span className={`w-2 h-2 rounded-full ${c.dot}`} />
              <h3 className="text-white font-medium">{c.label}</h3>
              <span className="text-xs text-[#52525B]">{data[c.key].length}</span>
            </div>
            <div className="space-y-2" data-testid={`roadmap-${c.key}`}>
              {data[c.key].length === 0 ? <p className="text-xs text-[#52525B]">Nothing here yet.</p> :
               data[c.key].map((r) => (
                <div key={r.id} className="rounded-xl border border-white/8 bg-[#121214] p-4">
                  <div className="text-white text-sm">{r.title}</div>
                  {r.description && <p className="text-xs text-[#71717A] mt-1 line-clamp-2">{r.description}</p>}
                  <div className="text-[10px] text-[#D4AF37] mt-2">{r.votes} votes</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PublicPage>
  );
}
